import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import * as ETVConstants from '../ETVConstants';
import { Save } from '@mui/icons-material';
import { Typography } from '@mui/material';

class URLCreatorDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { url: '', error: false, saving: false };
  }

  handleChange = (e) => {
    const raw = e.target.value;
    const url = raw.trim();
    this.setState({ url, error: !this.isValidUrl(url) });
  };

  isValidUrl = (value) => {
    try {
      const u = new URL(value);
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch {
      return false;
    }
  };

  // <-- arrow function keeps the correct `this`
  saveURL = () => {
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    const urlStr =
      ETVConstants.getServerBase() +
      '/url_creator?action=register_url&user_id=' +
      reqUserID +
      '&url=' +
      encodeURIComponent(this.state.url);

    this.setState({ saving: true });
    fetch(urlStr, { headers: { 'user_id': reqUserID, 'access_token': accessToken } })
      .then((res) => res.json())
      .then(
        (result) => {
          //console.log('res=' + JSON.stringify(result));
          this.setState({ saving: false });
          this.props.onAdded && this.props.onAdded();
        },
        () => this.setState({ saving: false })
      );
  };

  render() {
    const { open, onClose } = this.props;
    const { url, error, saving } = this.state;

    return (
      <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
        <DialogTitle>{ETVConstants.trans('add_url')}
            <Typography variant='body1' color='text.secondary'>{ETVConstants.trans("add_url_desc")}</Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 2 }} dividers>
            <TextField
                autoFocus
                margin="dense"
                label={ETVConstants.trans('url')}
                type="url"
                fullWidth
                value={url}
                onChange={this.handleChange}
                error={error}
                helperText={error ? ETVConstants.trans('invalid_url') : ''}
            />
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2 }}>
          <Button onClick={onClose} color="primary" size="small">
            {ETVConstants.trans('close')}
          </Button>
          <Button
            onClick={this.saveURL}
            color="primary"
            variant="contained"
            size="small"
            startIcon={<Save />}
            disabled={saving || error || url.trim() === ''}
          >
            {ETVConstants.trans('save')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default URLCreatorDialog;
